// ======================================================================
// File Name       : scoringReport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/scoringReport';

export function receiveReportData(data) {
  return {
    type: ActionTypes.OPEN_REPORT_DIALOG,
    data,
  };
}

export function receiveGetDetailDrill(data) {
  return {
    type: ActionTypes.GET_DETAIL_DRILL,
    data,
  };
}

export function receiveEditByCorrector(data) {
  return {
    type: ActionTypes.EDIT_BY_CORRECTOR,
    data,
  };
}

export function openedGroupSelectDialog(reportList) {
  return {
    type: ActionTypes.REPORT_LIST_OPEN_GROUP_DIALOG,
    reportList,
  };
}

export function doReceiveGroupStructureList(groupList) {
  return {
    type: ActionTypes.REPORT_LIST_GET_GROUP_LIST,
    groupList,
  };
}

export function doInitReportListSearchData(data, isValidUrl, mode) {
  return {
    type: ActionTypes.REPORT_LIST_INIT_SEARCH_INFO,
    data,
    isValidUrl,
    mode,
  };
}

export function doSelectedGroupFromDialog(reportList) {
  return {
    type: ActionTypes.SELECTED_GROUP_FROM_DIALOG,
    reportList,
  };
}

export function doReceivedSearchResult(searchResult) {
  return {
    type: ActionTypes.SCORING_REPORT_SEARCH,
    searchResult,
  };
}

export function receiveSaveModalReportData(modalReport) {
  return {
    type: ActionTypes.SAVE_MODAL_REPORT_DATA,
    modalReport,
  };
}

export function resetReportList() {
  return {
    type: ActionTypes.RESET_REPORT_LIST,
  };
}

export function handleButtonDisabled(buttonId) {
  return {
    type: ActionTypes.DISABLE_GET_REPORT_BUTTON,
    buttonId,
  };
}

export function resetDrillDetail() {
  return {
    type: ActionTypes.RESET_DETAIL_DRILL,
  };
}

// #7404 START
export function receivedDrillTopInfo(data) {
  return {
    type: ActionTypes.RECEIVED_DRILL_TOP_INFO,
    data,
  };
}

export function receivedEachQuestion(data) {
  return {
    type: ActionTypes.RECEIVED_EACH_QUESTION,
    data,
  };
}
// #7404 END
